/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_StrengthsInputs */

const en_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strengths`)
};

const de_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stärken`)
};

const fr_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points forts`)
};

const es_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortalezas`)
};

const it_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti di forza`)
};

const nl_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterke punten`)
};

const pl_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mocne strony`)
};

const fi_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvuudet`)
};

const da_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styrker`)
};

const sv_interview_practice_strengths = /** @type {(inputs: Interview_Practice_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styrkor`)
};

/**
* | output |
* | --- |
* | "Strengths" |
*
* @param {Interview_Practice_StrengthsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_strengths = /** @type {((inputs?: Interview_Practice_StrengthsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_StrengthsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_strengths(inputs)
	if (locale === "fr") return fr_interview_practice_strengths(inputs)
	if (locale === "es") return es_interview_practice_strengths(inputs)
	if (locale === "it") return it_interview_practice_strengths(inputs)
	if (locale === "nl") return nl_interview_practice_strengths(inputs)
	if (locale === "pl") return pl_interview_practice_strengths(inputs)
	if (locale === "fi") return fi_interview_practice_strengths(inputs)
	if (locale === "da") return da_interview_practice_strengths(inputs)
	if (locale === "sv") return sv_interview_practice_strengths(inputs)
	return en_interview_practice_strengths(inputs)
});